import { useEffect, useMemo } from 'react';

import confirmDialog from 'lib/confirmDialog';
import formatEmailMessage from 'screens/leadModal/leadModalChat/chatComposer/lib/formatEmailMessage';
import { closeLeadModal } from '../screens/leadModal/lib/closeLeadModal.js';
import setQuery from '../lib/setQuery.js';
import { useSelector } from 'react-redux';
import queryMap from 'lib/constants/queryMap.js';

const closeParameters = ['modal', 'eid', 'lead', 'replyTo', 'pipelineLeadId', 'type', 'contact', 'creating', 'todoId', 'creatingLead', 'noteId', 'nt'].map((n) => queryMap[n] || n);
const blacklistedDomElements = ['.confirm-dialog', '.image-popup.active', '.tox-dialog-wrap'];
let showConfirm = false;

const handleConfirmClose = async ({ type }, autoConfirm = false) => {
  const confirm = autoConfirm
    ? true
    : await confirmDialog({
        message: `Clicking confirm will cancel your current action. Continue?`,
        confirm: 'Confirm',
        cancel: 'Cancel',
      });
  if (confirm) {
    showConfirm = false;
    setQuery({ [type]: null, template: null });
  }
};

const EscapeKeyHandler = () => {
  const composerEmail = useSelector((state) => state.leadModal.composerEmail);

  const disabledSendMemo = useMemo(() => {
    let disableSend = ['subject', 'platformRegistrationId', 'contactDetailId'].filter((n) => !composerEmail[n]).length > 0;
    const messageValue = (formatEmailMessage(composerEmail.message) || '').trim();
    if ((messageValue || '').length === 0 || (messageValue || '') === '<p></p>') {
      disableSend = true;
    }
    return disableSend;
  }, [composerEmail]);

  const handleEscapeKeyDown = (e) => {
    e.stopPropagation();
    const closeParams = [...closeParameters].filter((n) => {
      if (n === 'nt') {
        return !window.location.pathname.includes('/pipelines');
      }
      return true;
    });
    if (e.keyCode === 27) {
      const queryMap = Object.fromEntries(new URLSearchParams(window.location.search));
      const queryList = Object.keys(queryMap) //
        .sort((a, b) => closeParams.indexOf(b) - closeParams.indexOf(a))
        .filter((n) => closeParams.includes(n));
      const activeElement = document.activeElement;
      const nextQuery = queryList[0];
      let matchedBlacklist = blacklistedDomElements.find((n) => !![...document.querySelectorAll(n)].length);
      if (matchedBlacklist) {
        return;
      }
      const ignoreEscapeKeyHandler = activeElement.getAttribute('data-ignore-escape-key-handler');
      if (String(ignoreEscapeKeyHandler) === 'true') {
        return;
      }
      if (activeElement && ['SELECT'].includes(activeElement.nodeName)) {
        return activeElement.blur();
      }
      if (activeElement && ['INPUT', 'TEXTAREA'].includes(activeElement.nodeName)) {
        if (activeElement.innerHTML !== '') {
          return activeElement.blur();
        }
      }
      if (['l', 'ei'].includes(nextQuery)) {
        closeLeadModal();
        return;
      }
      if (nextQuery === 'e' && showConfirm === false) {
        // todo
        handleConfirmClose({ type: nextQuery });
        return;
      }
      setQuery({ [nextQuery]: null });
    }
  };

  useEffect(() => {
    showConfirm = disabledSendMemo;
    document.addEventListener('keydown', handleEscapeKeyDown);
    return () => document.removeEventListener('keydown', handleEscapeKeyDown);
  }, [disabledSendMemo]);

  return null;
};

export default EscapeKeyHandler;
